export default __webpack_public_path__ + "static/media/char_broiler_01.80da58aa.png";